/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');
var Ladda = require('ladda');
var toggleForm = require('common/util/toggleForm');

var BreadcrumbView = require('common/views/BreadcrumbView');
var NonDepInternalSidebarNavView = require('../../common/views/NonDepInternalSidebarNavView');

var SubmitInternalNewEntity = require('../services/SubmitInternalNewEntity');

require('../styles/NonDepInternalNewEntityView.css');
var tmplNonDepInternalEntityFormView = require('../templates/NonDepInternalEntityFormView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepInternalEntityFormView,

  className: 'nondep-internal-new-entity-view container-fluid',

  ui: {
    sideBar: '.side-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    newEntityForm: '.new-entity-form',
    organizationTypeId: '.organization-type-id',
    tinContainer: '.tin-container',
    ssnContainer: '.ssn-container',
    submit: '.btn-submit'
  },

  regions: {
    breadCrumbContainer: '@ui.breadCrumbContainer',
    sideBar: '@ui.sideBar'
  },

  events: {
    'click @ui.submit': 'onClickSubmit',
    'change @ui.organizationTypeId': 'onChangeOrganizationType'
  },

  onBeforeShow: function() {
    this.showChildView('sideBar', new NonDepInternalSidebarNavView());

    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#nondep/dashboard'
          },
          {
            text: 'Create A New Entity'
          }
        ]
      })
    );
    toggleForm(this.ui.tinContainer, true);
    toggleForm(this.ui.ssnContainer, false);
  },

  onChangeOrganizationType: function() {
    var isSoleProp = this.ui.organizationTypeId.val() === '6';
    toggleForm(this.ui.ssnContainer, isSoleProp);
    toggleForm(this.ui.tinContainer, !isSoleProp);
  },

  onClickSubmit: function(e) {
    e.preventDefault();

    this.ui.newEntityForm
      .parsley()
      .whenValidate()
      .done(
        function() {
          var laddaContext = Ladda.create(this.ui.submit.get(0));
          laddaContext.start();
          SubmitInternalNewEntity(this.getFormData())
            .done(function(newEntityId) {
              Radio.channel('navigate').trigger('show:int:nd:entity-dashboard', newEntityId);
            })
            .fail(function() {
              laddaContext.stop();
            });
        }.bind(this)
      );
  },

  getFormData: function() {
    var formData = Syphon.serialize(this.ui.newEntityForm);
    // If sole proprietor, set TIN Type as SSN, else EIN
    if (this.ui.organizationTypeId.val() === '6') {
      formData.tinTypeId = '2';
    } else {
      formData.tinTypeId = '1';
    }
    return formData;
  }
});
